// extracted by mini-css-extract-plugin
export default {"note":"style_note__U5gdG","link":"style_link__oNp06"};